import { createFileRoute, redirect } from '@tanstack/react-router';

// 旧・終了済み専用画面（廃止）の互換ルート。ブックマーク・共有済みリンクが
// Not Found にならないよう、メイン一覧の TERMINATED ステータスタブへ誘導する。
export const Route = createFileRoute('/_staff/business-partner/_list/terminated/')({
  beforeLoad: () => {
    throw redirect({
      to: '/business-partner',
      search: {
        businessPartnerStatusIn: ['TERMINATED']
      }
    });
  }
});